import * as settlementTask from './settlement-task'
import * as settlementDocument from './settlement-document'
import * as saleCollection from './sale-collection'
import * as saleRedCollection from './red-sale-collection'
export default [settlementTask,settlementDocument,saleCollection,saleRedCollection]


// WEBPACK FOOTER //
// ./src/store/modules/settlement-center/index.js